export const template = `
    <div class="dz-preview dz-file-preview">
        <div class="dz-image">
            <div data-dz-thumbnail-bg></div>
            <div class="dz-processing-status">
                <i class="fa fa-spinner fa-spin fa-2x"></i>
            </div>
        </div>
        <div class="dz-details">
            <div class="dz-filename"><a href="#"><span data-dz-name></span></a></div>
        </div>
    </div>
`;

export function thumbnail(file, dataUrl) {
    let j, len, ref, thumbnailElement, anchorElement;
    if (file.previewElement) {
        file.previewElement.classList.remove("dz-file-preview");

        // dodanie tła
        if (dataUrl) {
            ref = file.previewElement.querySelectorAll("[data-dz-thumbnail-bg]");
            for (j = 0, len = ref.length; j < len; j++) {
                thumbnailElement = ref[j];
                thumbnailElement.alt = file.name;
                thumbnailElement.style.backgroundImage = 'url("' + dataUrl + '")';
            }
        }

        // atrybut uuid dla linku
        ref = file.previewElement.querySelectorAll(".dz-details .dz-filename a");
        for (j = 0, len = ref.length; j < len; j++) {
            anchorElement = ref[j];
            anchorElement.dataset.serverUuid = file.serverUuid;
        }

        return setTimeout(((function() {
            return function() {
                return file.previewElement.classList.add("dz-image-preview");
            };
        })(this)), 1);
    }
}